import React, { lazy, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import isbot from "isbot";

import {
  Routes as Switch,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import { GetUserByRefresh, LogoutBlacklist } from "./services/account";
import { actions as authActions } from "./store/authRedux/actions";
import { actions as commonActions } from "./store/commonRedux/actions";

import OnBoardingRoutes from "./routes/OnBoarding";
import CommonRoutes from "./routes/Common";
import B2CRoutes from "./routes/B2C";
import B2BRoutes from "./routes/B2B";

import PageLayout from "./layout";
import Pictures from "pages/Common/Pictures";
import CheckCredit from "pages/Common/CheckCredit";
import InfoAppModal from "components/InfoAppModal";

const JWTDELAY = 250000;

const Routes = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { isOnBoarded, channelId, isInfoSeen } = useSelector(({ common }) => ({
    isOnBoarded: common.onboarding,
    channelId: common.channelId,
    isInfoSeen: common.isInfoSeen,
  }));

  const { refreshToken, userInfo, isAuthorized } = useSelector(
    ({ auth }) => ({
      refreshToken: auth.refresh,
      accessToken: auth.access,
      isAuthorized: auth.user != null,
      userInfo: auth.user,
    }),
    shallowEqual,
  );

  const renderRoutes = () => {
    const flag = isOnBoarded
      ? isAuthorized
        ? channelId
        : "B2C"
      : "onboarding";

    switch (flag) {
      case "onboarding":
        return OnBoardingRoutes.map(({ path, element }) => (
          <Route path={path} element={element} />
        ));

      case "B2C":
        return [...B2CRoutes, ...CommonRoutes].map(({ path, element }) => (
          <Route path={path} element={element} />
        ));

      case "B2B":
        if (userInfo.b2b_status == "IDLE") {
          return B2BRoutes.Idle.map(({ path, element }) => (
            <Route path={path} element={element} />
          ));
        } else if (["REJECTED", "PENDING"].includes(userInfo.b2b_status)) {
          return B2BRoutes.Waiting.map(({ path, element }) => (
            <Route path={path} element={element} />
          ));
        } else {
          return [...B2BRoutes.Main, ...CommonRoutes].map(
            ({ path, element }) =>
              path == "/login" ? (
                <Route
                  path={path}
                  element={isAuthorized ? <Navigate to={"/"} /> : element}
                />
              ) : (
                <Route path={path} element={element} />
              ),
          );
        }

      default:
        return [...CommonRoutes, ...B2CRoutes].map(({ path, element }) => (
          <Route path={path} element={element} />
        ));
    }
  };

  useEffect(() => {
    if (isAuthorized) {
      try {
        const refreshAccessToken = setInterval(async () => {
          await GetUserByRefresh(refreshToken).then((res) => {
            dispatch(authActions.refresh(res.access));
          });
        }, JWTDELAY);
        return () => {
          clearInterval(refreshAccessToken);
        };
      } catch (err) {
        if (!err.response) return;
        LogoutBlacklist(refreshToken);
        dispatch(authActions.logout());
      }
    }

    if (isbot(navigator.userAgent)) {
      dispatch(commonActions.setOnBoarding(true));
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const body = document.querySelector("#root");
      body.scrollIntoView(
        {
          behavior: "smooth",
        },
        500,
      );
    }, 100);
  }, [location.pathname]);

  return (
    <PageLayout>
      {/* <InfoAppModal isOpen={!isInfoSeen} />  */}
      <Switch>
        {renderRoutes()}
        <Route path={"/pictures"} element={<Pictures />} />
        <Route path={"/check-credit"} element={<CheckCredit />} />
      </Switch>
    </PageLayout>
  );
};

export default Routes;
